import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  loadingPatientSurgeries,
  loadedPatientSurgeries,
  failedPatientSurgeries,
  loadingPatientSurgery,
  loadedPatientSurgery,
  failedPatientSurgery,
  changeFilters,
} from "../../store/doctor/patientSurgerySlice";
import { translations, sleep } from "../../helpers";

export const usePatientSurgeryStore = () => {
  const dispatch = useDispatch();

  const { patientSurgeries, patientSurgery, filters, pagination } = useSelector(
    (state) => state.doctor.patientSurgery
  );

  const getPatientSurgery = useCallback(
    async ({ filters, pagination, date = null }) => {
      try {
        dispatch(loadingPatientSurgeries());

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        const { totalPages, ...filteredPagination } = pagination;

        // console.log("filteredParams", filteredParams);

        const { data } = await gosafeApi.get("doctor/patientSurgery", {
          params: {
            ...filteredPagination,
            ...filteredParams,
            date,
          },
        });

        // console.log("data", data);

        dispatch(loadedPatientSurgeries(data));

        return;
      } catch (error) {
        dispatch(
          failedPatientSurgeries(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch]
  );

  const getSearch = useCallback(
    async (filters) => {
      dispatch(changeFilters(filters));

      await getPatientSurgery({ filters, pagination });
    },
    [dispatch, pagination]
  );

  const updatePatientSurgery = useCallback(
    async (patients) => {
      try {
        dispatch(loadingPatientSurgery());
        const { data } = await gosafeApi.put("patientSurgery", patients);
        dispatch(loadedPatientSurgery(data));
        await sleep(5000);
        dispatch(loadingPatientSurgery());
      } catch (error) {
        dispatch(
          failedPatientSurgery(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch]
  );

  return {
    // Props
    patientSurgeries,
    filters,
    pagination,
    patientSurgery,

    // Methods
    getPatientSurgery,
    getSearch,
    updatePatientSurgery,
  };
};
